import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import { Zap, , CheckCircle } from 'lucide-react';
import { Zap,  ArrowRight, Users, Award, Target, CheckCircle } from 'lucide-react';

const AboutPage = () => {

  // ⭐ MODAL STATE
  const [selectedMember, setSelectedMember] = useState(null);

  // ⭐ FULL TEAM DATA
  const teamMembers = [
    {
      name: 'Amy Vargas',
      // role: 'Ace Team',
      image: '/Images/Amy Vargas - Copy.jpg',
      // bio: 'Amy has over 10 years of experience in dental lab operations, specialising in patient support and quality assurance.'
    },
    {
      name: 'Elena Cirlan',
      // role: 'Ace Team',
      image: '/Images/Elena Cirlan .jpg',
      // bio: 'Elena oversees production workflow and ensures high-quality dental restorations at Ace Dental.'
    },
    {
      name: 'Hugo Sanchez',
      // role: 'Ace Team',
      image: '/Images/Hugo Sanchez.jpg',
      // bio: 'Hugo handles digital scanning and CAD/CAM designing with expertise in implant workflows.'
    },
    {
      name: 'Saddam Sharif',
      // role: 'Ace Team',
      image: '/Images/Saddam Sharif .jpg',
      // bio: 'Saddam is known for precision work in ceramics and cosmetic dental aesthetics.'
    },
    {
      name: 'Stefanie Sevilla',
      // role: 'Ace Team',
      image: '/Images/Stefanie Sevilla .jpg',
      // bio: 'Stefanie manages client support, communication, and laboratory coordination.'
    },
    {
      name: 'Suzana Duka',
      // role: 'Ace Team',
      image: '/Images/Suzana Duka.jpg',
      // bio: 'Suzana specializes in quality control and final restoration checks before delivery.'
    }
  ];

  const facilities = [
    {
      title: "Our Facilities",
      description: "State-of-the-art equipment and a modern, welcoming environment. We're equipped with the latest dental technology to ensure precision, safety, and comfort in every procedure.",
       //  image: "/Images/IMG_4019homepage.webp",
      icon: <Award className="w-8 h-8 text-black" />
    },
    {
      title: "Our Staff",
      description: "Experienced dental technicians and lab specialists, committed to precision and excellence in every dental solution we provide.",
      icon: <Users className="w-8 h-8 text-black" />
    },
    {
      title: "Our Plans",
      description: "Flexible solutions designed for your dental lab needs. From custom crowns and bridges to advanced prosthetic devices, we provide personalized dental lab services.",
      icon: <Target className="w-8 h-8 text-black" />
    }
  ];

    const features = [
    {
      icon: <Zap className="w-8 h-8 text-black-400" />,
      title: "Fast Digital Solutions",
      description: "Full Arch Zirconia in just three appointments with advanced digital workflows."
    },
    {
      icon: <Award className="w-8 h-8 text-black-400" />,
      title: "Premium Quality",
      description: "High-quality restorations with precision and care using cutting-edge technology."
    },
    {
      icon: <Users className="w-8 h-8 text-black-400" />,
      title: "Expert Craftsmanship",
      description: "Trusted partner for dental professionals delivering confident smiles every day."
    }
  ];

  const whyChooseUs = [
    "Expert dental team",
    "Modern lab technology", 
    "Quick turnaround",
    "Customized plans"
  ];

  return (
    <div className="min-h-screen pt-16">

      {/* Hero Section */}
      <section className=" bg-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            <div>
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                Innovating Today for a{' '}
                {/* text-transparent */}
                <span className="bg-gradient-to-r text-white bg-clip-text text-black  ">
                  Better Tomorrow
                </span>
              </h1>

              <p className="text-lg text-white leading-relaxed mb-8">
                At Ace Dental Lab, we offer high-quality dental care with a focus on comfort, precision, and lasting results.
              </p>

              {/* <Link 
                to="/contact"
                className="inline-flex items-center bg-white text-black px-8 py-4 rounded-lg font-medium"
              >
                Send Case 
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link> */}
            </div>

            <div className="lg:pl-8">
              {/* {<video
    className=" "
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/Images/Animation.mp4" type="video/mp4" />
  </video> } */}
              {/* <img alt="Ace Dental Lab"  src='/Images/IMG_9262-2.jpg'
               className="w-full rounded-2xl shadow-2xl" /> */}
            </div>

          </div>
        </div>
      </section>



        {/* Facilities Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Your Smile, Your Health</h2>
            <h3 className="text-2xl font-semibold text-white  mb-8">About Us</h3>
          </div>

          <div className="grid lg:grid-cols-3 gap-8"  >
            {facilities.map((facility, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl shadow-lg border border-blue-100">
                
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    {facility.icon}
                    <h3 className="text-xl font-semibold text-gray-900 ml-3"
                      onClick={() => {
                        if(facility.title == "Our Staff")  {
                              document
                .getElementById("team-section")
                .scrollIntoView({ behavior: "smooth" });
                }
            }}

                        
          
                    
                    
                    
                    
                    >{facility.title}  </h3>
                  </div>
                  <p className="text-gray-600">{facility.description}</p>
                </div>

              </div>
            ))}
          </div>

        </div>
      </section>


    



     


         
            {/* Who We Are Section */}
            {/* style={{ backgroundImage: "url('/Images/bg blackedit.jpg')" }} */}
                 <section className="py-10  bg-black"   >
                   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                     <div className="grid lg:grid-cols-2 gap-12 items-center">
                       <div>
                         <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                           Who We Are
                         </h2>
                         <p className="text-lg text-white leading-relaxed mb-8">
                           Ace Dental Lab is a trusted partner for dental professionals, delivering high-quality restorations with precision and care. Combining advanced technology and expert craftsmanship, we help create confident smiles every day.
                         </p>
                         <Link
                           to="/contact"
                           className="inline-flex items-center text-white font-medium hover:text-white transition-colors group"
                         >
                           Send Case 
                           <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                         </Link>
                       </div>
           
                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                         {features.map((feature, index) => (
                           <div key={index} className="bg-gradient-to-br from-slate-50 to-blue-50 p-6 rounded-xl border border-blue-100">
                             <div className="mb-4">{feature.icon}</div>
                             <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                             <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                           </div>
                         ))}
                       </div>
                     </div>
                   </div>
                 </section>




                 


                 
         




    

      {/* TEAM SECTION */}
      {/* bg-gradient-to-r from-slate-50 to-blue-50 */}
      <section className="py-10  bg-black ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

          {/* <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Meet with the best
          </h2> */}

          <h3 className="text-2xl font-semibold text-white mb-12"  id="team-section"  >
            MEET OUR TEAM
          </h3>

          {/* Team Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                onClick={() => setSelectedMember(member)}   // ⭐ open modal
                className="cursor-pointer overflow-hidden rounded-xl shadow-lg border border-gray-200 hover:shadow-2xl transition-all duration-300"
              >
                <div className="h-80 w-full overflow-hidden">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <div className="bg-black py-4 text-center">
                  <h4 className="text-white font-semibold uppercase">{member.name}</h4>
                  <p className="text-white/90 text-sm">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
          {/* <Link 
            to="/about"
            className="inline-flex items-center text-black-600 font-medium text-lg"
          >
            MEET OUR TEAM
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link> */}
        </div>
      </section>

      {/* ⭐ MODAL */}
      {selectedMember && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6 relative">

            {/* Close */}
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
              onClick={() => setSelectedMember(null)}
            >
              ✕
            </button>

            <img 
              src={selectedMember.image}
              className="w-36 h-36 rounded-full object-cover mx-auto mb-4"
            />

            <h2 className="text-2xl font-bold text-center">{selectedMember.name}</h2>
            <p className="text-center text-gray-600">{selectedMember.role}</p>

            <p className="mt-4 text-gray-700 text-center">{selectedMember.bio}</p>
          </div>
        </div>
      )}







          {/* Text-Only Professional Section */}
<section className="py-10 bg-black">
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
        What Makes Us Different
      </h2>
      <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
        Ace Dental Lab is built on a commitment to reliability, precision, and 
        a service-first mindset. Here’s how we deliver consistent excellence.
      </p>
    </div>

    {/* 3-Column Text Grid */}
    <div className="grid md:grid-cols-3 gap-10 mb-20">

      {/* Item 1 */}
      <div className="p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition">
        <h3 className="text-xl font-semibold text-white mb-3">
          Consistency in Every Case
        </h3>
        <p className="text-white leading-relaxed">
          Every restoration is created with strict attention to detail, 
          ensuring predictable and reliable results for every patient.
        </p>
      </div>

      {/* Item 2 */}
      <div className="p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition">
        <h3 className="text-xl font-semibold text-white mb-3">
          Clear Communication
        </h3>
        <p className="text-white leading-relaxed">
          We maintain an open line of communication with our doctors, 
          providing updates, guidance, and case support whenever needed.
        </p>
      </div>

      {/* Item 3 */}
      <div className="p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition">
        <h3 className="text-xl font-semibold text-white mb-3">
          Commitment to Quality
        </h3>
        <p className="text-white leading-relaxed">
          Our team follows quality protocols to ensure every product is checked, 
          refined, and approved with care.
        </p>
      </div>

    </div>

    {/* Long Description Section */}
    <div className="max-w-4xl mx-auto text-center">
      <h3 className="text-2xl font-semibold text-white mb-4">
        Dedicated to Supporting Your Practice
      </h3>
      <p className="text-white text-lg leading-relaxed">
        At Ace Dental Lab, we believe in building long-term professional 
        relationships. Our goal is to help dental practices deliver their best 
        by providing restorations that match technical accuracy with aesthetic excellence. 
        We are driven by trust, craftsmanship, and the commitment to elevate each smile.
      </p>
    </div>

  </div>
</section>








      {/* Other Sections... (You didn’t ask to modify these) */}

      <section className="py-20  bg-black">
        <div className="max-w-7xl mx-auto text-center px-4">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Ready to Experience Excellence?
          </h2>
          <p className="text-lg text-white mb-8 max-w-2xl mx-auto">
            Connect with our expert team today and discover how our advanced technology can enhance your dental practice.
          </p>

          {/* <Link 
            to="/contact"
            className="inline-flex items-center bg-black text-white px-8 py-4 rounded-lg"
          >
            Book Consultation
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link> */}

        </div>
      </section>

    </div>
  );
};

export default AboutPage;
